import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "hot-course-container" }
const _hoisted_2 = { class: "layout" }
const _hoisted_3 = {
  class: "course-list-container",
  style: { height: 560 + 'px' }
}
const _hoisted_4 = { class: "course-list" }
const _hoisted_5 = ["onMouseenter", "onClick"]
const _hoisted_6 = { class: "course-name" }
const _hoisted_7 = {
  key: 0,
  class: "active-indicator"
}
const _hoisted_8 = {
  class: "carousel-container",
  style: { height: 560 + 'px' }
}
const _hoisted_9 = { class: "course-card" }
const _hoisted_10 = { class: "image-container" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "text-overlay" }
const _hoisted_13 = { style: {"text-align":"left"} }

import { ref, onMounted, nextTick } from 'vue';
import { contentService } from '@/services/ContentService';
import { GetCourseByTypeRequest } from '@/types/course/request/GetCourseByTypeRequest';
import { UserInfo } from '@/types/user/UserInfo'
import { ElCarousel, ElCarouselItem, ElAvatar, ElButton } from 'element-plus';
import 'element-plus/es/components/carousel/style/css';
import 'element-plus/es/components/avatar/style/css';
import 'element-plus/es/components/button/style/css';
import LoginDialogComponent from '@/components/home/LoginDialogComponent.vue';
import { Course } from '@/types/course/request/Course';
import router from "@/router/index"
import { ElMessage } from 'element-plus';
// 定义请求参数

export default /*@__PURE__*/_defineComponent({
  __name: 'HotCourseComponent',
  setup(__props) {

const getCourseByTypeRequest = ref<GetCourseByTypeRequest>({
    status: 1,
    limit: 10, // 固定 10 条数据
    page: 1,
});

// 定义课程数据
const courses = ref<Course[]>();

// 默认封面图片
const defaultCover = ref('https://via.placeholder.com/300x150?text=No+Cover');

// 当前激活的课程索引
const activeIndex = ref(0);

// 获取轮播图实例
const carouselRef = ref<InstanceType<typeof ElCarousel>>();

// 左侧课程列表高度
const listHeight = ref(0);

// 用户信息
const localStorageUser = ref<UserInfo>();

// 控制登录弹窗显示
const showLogin = ref(false);
// 判断是否为平板端
const isTablet = ref(false);


// 在组件挂载时调用方法
onMounted(async () => {
    const storedUserInfo = localStorage.getItem('user');
    if (storedUserInfo) {
        localStorageUser.value = JSON.parse(storedUserInfo);
    }

     // 检测设备是否为平板端
    checkIfTablet();

    try {
        const response = await contentService.get_courses_by_type(getCourseByTypeRequest.value);
        courses.value = response.data.courses;

        // 等待 DOM 更新完成后计算高度
        nextTick(() => {
            calculateListHeight();
        });
    } catch (error) {
        console.error('获取课程数据失败:', error);
    }
});

// 检测设备是否为平板端
const checkIfTablet = () => {
    const width = window.innerWidth;
    isTablet.value = width >= 769 && width <= 1024;
};


// 计算左侧课程列表高度
const calculateListHeight = () => {
    const liElement = document.querySelector('.course-list li');
    if (liElement) {
        const liHeight = liElement.clientHeight; // 获取单个 <li> 的高度
        const padding = 10; // 假设每个 <li> 之间有 10px 的间距
        listHeight.value = (liHeight + padding) * 10; // 10 个 <li> 的总高度
    }
    console.log("高度：" + listHeight.value)
};

// 鼠标移入课程列表项时触发
const handleCourseHover = (index: number) => {
    activeIndex.value = index; // 更新高亮项
    if (carouselRef.value) {
        carouselRef.value.setActiveItem(index); // 切换轮播图
    }
};

// 点击课程列表项时切换轮播图
const handleCourseClick = (course: Course) => {
    
        router.push({
            name: 'information',
            params: { courseId: String(course.id) } // 仅传递 course 的 id
        });
    
};

// 轮播图切换时更新高亮项
const handleCarouselChange = (currentIndex: number) => {
    activeIndex.value = currentIndex;
};

// 跳转到个人中心
const goto_usercenter = () => {
    console.log('跳转到个人中心');
     router.push({
        name: 'personalCenter'
    });
};

// 退出登录
const login_out = () => {
    console.log('退出登录');
    // 清除 token
    localStorage.removeItem('token');
    // 清除 user 信息
    localStorage.removeItem('user');
    localStorageUser.value = undefined;
    ElMessage.success("退出登录成功！")
};

// 显示登录弹窗
const showLoginDialog = () => {
    showLogin.value = true;
};

// 处理登录成功事件
const handleLoginSuccess = (userInfo: UserInfo) => {
     
    localStorage.setItem('user', JSON.stringify(userInfo));
    localStorageUser.value = userInfo;
    showLogin.value = false;
    ElMessage({
        message: '登录成功',
        type: 'success',
        duration: 2000, // 设置为 0，表示提示不会自动关闭
    });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h1", { style: {"display":"flex"} }, "热门课程", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courses.value, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.id,
              class: _normalizeClass({ active: activeIndex.value === index }),
              onMouseenter: ($event: any) => (handleCourseHover(index)),
              onClick: ($event: any) => (handleCourseClick(item))
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(item.coursename), 1),
              (activeIndex.value === index)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "▶"))
                : _createCommentVNode("", true)
            ], 42, _hoisted_5))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(ElCarousel), {
          "indicator-position": "none",
          interval: 5000,
          arrow: "always",
          height: 560 + 'px',
          ref_key: "carouselRef",
          ref: carouselRef,
          onChange: handleCarouselChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courses.value, (item) => {
              return (_openBlock(), _createBlock(_unref(ElCarouselItem), {
                key: item.id,
                onClick: ($event: any) => (handleCourseClick(item))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("img", {
                        src: item.cover || defaultCover.value,
                        alt: "course cover",
                        class: "course-cover"
                      }, null, 8, _hoisted_11),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("h3", null, _toDisplayString(item.coursename), 1),
                        _createElementVNode("p", _hoisted_13, _toDisplayString(item.description), 1)
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128))
          ]),
          _: 1
        }, 512)
      ])
    ]),
    _createVNode(LoginDialogComponent, {
      visible: showLogin.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((showLogin).value = $event)),
      onLoginSuccess: handleLoginSuccess
    }, null, 8, ["visible"])
  ]))
}
}

})